"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultClassActivator = void 0;
class DefaultClassActivator {
    activate(type) {
        return new type();
    }
}
exports.DefaultClassActivator = DefaultClassActivator;
//# sourceMappingURL=ClassActivator.js.map